import CalendarTime from 'owa-calendar-time-host/lib/schema/CalendarTime';
import RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import { action } from 'satcheljs';
import { OwaDate } from 'owa-datetime';

/**
 * Action called to update the all day flag in the store
 */
export let updateAllDay = action(
    'updateAllDay',
    (isAllDayEvent: boolean, calendarTime: CalendarTime) => ({
        isAllDayEvent: isAllDayEvent,
        calendarTime: calendarTime,
    })
);

/**
 * Action called to update the start and end time in the store
 */
export let updateStartAndEndTime = action(
    'updateStartAndEndTime',
    (Start: OwaDate, End: OwaDate, CalendarTime: CalendarTime) => ({
        Start: Start,
        End: End,
        CalendarTime: CalendarTime,
    })
);

//// SECTION: Orchestrator Actions

/**
 * Action called when all day flag is updated. This calls an orchestrator
 */
export let onAllDayChanged = action(
    'onAllDayChanged',
    (isAllDayEvent: boolean, calendarTime: CalendarTime) => ({
        isAllDayEvent: isAllDayEvent,
        calendarTime: calendarTime,
    })
);

/**
 * Action called when recurrence is updated. This calls a mutator
 */
export let setRecurrence = action(
    'setRecurrence',
    (recurrenceType: RecurrenceType, calendarTime: CalendarTime) => ({
        recurrenceType: recurrenceType,
        calendarTime: calendarTime,
    })
);

/**
 * Action called when recurrenceTimeZone is updated. This calls a mutator
 */
export let setTimeZoneName = action(
    'setTimeZoneName',
    (timeZone: string, calendarTime: CalendarTime) => ({
        timeZone: timeZone,
        calendarTime: calendarTime,
    })
);
